import { useT } from "@/i18n/LanguageContext";
import { useSettings } from "@/hooks/useSettings";

export default function WhatsAppFab() {
  const t = useT();
  const { whatsapp_supreme } = useSettings();
  const digits = (whatsapp_supreme || "").replace(/\D/g, "") || "380759878825";
  const href = `https://wa.me/${digits}?text=${encodeURIComponent(t("wa.msg"))}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("wa.label")}
      data-testid="whatsapp-fab"
      className="group fixed z-50 bottom-5 right-5 sm:bottom-6 sm:right-6 flex items-center gap-2 pl-3.5 pr-4 py-3 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white font-bold uppercase tracking-wider text-[11px] shadow-[0_8px_28px_rgba(37,211,102,0.55)] hover:shadow-[0_10px_36px_rgba(37,211,102,0.75)] transition-all hover:-translate-y-0.5"
    >
      <span className="relative flex items-center justify-center w-6 h-6">
        <span className="absolute inset-0 rounded-full bg-white/25 animate-ping" />
        {/* Official WhatsApp glyph */}
        <svg
          viewBox="0 0 32 32"
          className="w-5 h-5 relative"
          aria-hidden="true"
          fill="currentColor"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.612 3.41 4.704 4.24.214.085.46.17.717.215.388.043.673.108.99.108.487 0 1.13-.117 1.484-.323.4-.244.643-.6.6-1.16 0-.215-.072-.444-.143-.66-.13-.245-.602-.388-.86-.5-.27-.115-.658-.215-.93-.215zM16.084 4.005c-6.78 0-12.272 5.49-12.272 12.27 0 2.314.652 4.486 1.785 6.328L4 28l5.483-1.43a12.243 12.243 0 0 0 6.6 1.945c6.78 0 12.272-5.492 12.272-12.273S22.864 4.005 16.084 4.005zm0 22.473a10.18 10.18 0 0 1-5.595-1.673l-.4-.243-4.05 1.06 1.073-3.965-.258-.413a10.16 10.16 0 0 1-1.55-5.42c0-5.625 4.575-10.2 10.2-10.2 5.624 0 10.2 4.576 10.2 10.2 0 5.626-4.576 10.2-10.2 10.2z" />
        </svg>
      </span>
      <span className="hidden sm:inline">{t("wa.label")}</span>
    </a>
  );
}
